import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { PropertyKind } from '../property'

@Directive({
  selector: '[appPropertyKindSelect]',
})
export class PropertyKindSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'context.kind'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(
      PropertyKind,
      'properties.kind',
      false
    )
  }
}
